<script setup lang="ts">
import {type NavigationItem} from "#magnolia-layer/types/api";

const props = defineProps<{
  item: NavigationItem;
}>();
const resolvedName = computed(() => resolveName(props.item, props.item));
const resolvedItem = computed(() => resolveLink(props.item));
</script>

<template>
  <NuxtLinkLocale :target="resolvedItem.target" :to="resolvedItem.link">
    {{ resolvedName }}
  </NuxtLinkLocale>
</template>

<style scoped lang="scss"></style>
